import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import classnames from 'classnames'
import { indexMap } from '@helpers'
import BlockTitle from '@components/BlockTitle'
import Brochure from '@components/Brochure'
import Link from 'gatsby-link'
import NavLinkBlock from '../NavLinkBlock'
import './Submenu.module.scss'

const renderSubMenu = (data, click) =>
  indexMap(
    (item, index) => {
      let externalLink = R.pathOr('', ['externalLink'], item)
      // console.log(externalLink)
      return (
        <li key={`submenu-${index}`} styleName='subitem'>
          {externalLink ? <a href={externalLink} styleName='sublink' target='_blank' rel='noopener noreferrer'>{R.prop('title', item)}</a>
            : <Link to={`/${R.pathOr('', ['link', 'slug'], item)}`} onClick={() => click()} styleName='sublink'>{R.prop('title', item)}</Link>}
        </li>
      )
    },
    data
  )

const Submenu = ({ item, showSubmenu, click }) => {
  const subMenu = R.propOr([], 'subMenu', item)
  const showContent = R.prop('showContent', item)
  const brochure = R.prop('brochure', item)
  const linkBox = R.prop('linkBox', item)
  const title = R.prop('title', item)
  const content = R.path(['content', 'content'], item)

  return (
    <div styleName={classnames('submenu', { show: showSubmenu })}>
      {showContent && (
        <div styleName='subcontent' onClick={() => click()}>
          <span>{title && <BlockTitle title={title} />}</span>
          {content && <p styleName='text'>{content}</p>}
          {linkBox && <NavLinkBlock linkBox={linkBox} />}
          {brochure && <Brochure brochure={brochure} key='0' simple />}
        </div>
      )}
      <ul styleName={classnames('sublinks', { split: showContent })}>{renderSubMenu(subMenu, click)}</ul>
    </div>
  )
}

Submenu.propTypes = {
  click: PropTypes.func,
  showSubmenu: PropTypes.bool
}

Submenu.defaultProps = {
  click: () => {},
  showSubmenu: false
}

export default Submenu



// WEBPACK FOOTER //
// ./src/components/PrimaryNavigation/Submenu/Submenu.js